import { SelectableChatLink } from "./LinkPreview";

const URL_RE = /(https?:\/\/[^\s<>"']+)/gi;

type Props = {
  text: string;
  className?: string;
};

/** Preserve newlines; make http(s) URLs clickable without turning the whole bubble into a card. */
export default function LinkifiedChatText({ text, className = "" }: Props) {
  const parts = String(text || "").split(URL_RE);
  return (
    <div
      className={`whitespace-pre-wrap break-words ${className}`.trim()}
      style={{ overflowWrap: "anywhere" }}
    >
      {parts.map((part, i) => {
        if (/^https?:\/\//i.test(part)) {
          const href = part.replace(/[),.;]+$/, "");
          return (
            <SelectableChatLink
              key={`${i}-${href}`}
              href={href}
              className="text-[#027EB5]"
            >
              {part}
            </SelectableChatLink>
          );
        }
        return <span key={i}>{part}</span>;
      })}
    </div>
  );
}
